import Vue from 'vue';
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuelidate)
Vue.use(Vuetify)

import App from './App.vue'
import Axios from 'axios'
import store from './store'
import router from './router'
import VueMask from 'v-mask'
import VueMeta from 'vue-meta'
import axios from './service'
import Notifications from 'vue-notification'

Vue.prototype.$axios = axios
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(Notifications)
Vue.use(VueMask);
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
const vuetify = new Vuetify();

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

export const bus = new Vue();

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');